import moment from "moment";
import { validateOverallPageFrom, validateOverallPageTo } from "./validationSchema835Lte";

const isValidDate = (dateStr) => {
  const minValidDate = moment("01/01/1900", "MM/DD/YYYY"); // baseline

  if (!dateStr || dateStr.replace("__/__/____", "") === "") return true;

  const date = moment(dateStr, "MM/DD/YYYY", true);

  return date.isValid() && date.isSameOrAfter(minValidDate);
};

export const validateField = (fieldName, values ,context) => {
if (values.qdx_status === "INCOMPLETE") return null;
    const {
totalPages,
jobData,
isSubJob,
isFirstJob,
isPayerPage,
isPayeePage,
isAdditional,
isAdditionalInfoOptions,
qdxTransaction,
isRarcCarcValidData,
transactionType,} = context;

  switch (fieldName) {
    case "check_number":
      if (!values.check_number) return "Required";
      break;

    case "check_date":
      if (!values.check_date) return "Required";
      if (!isValidDate(values.check_date)) return "Invalid date";
      break;

    case "check_amount":
      if (!values.check_amount) return "Required";
      if (values?.is_check_amount !== "" && values?.is_check_amount !== values?.check_amount) {
        return "Invalid check amount";
      }
      break;

    case "payer_account_number":
      if (!values.payer_account_number) return "Required";
      break;

    case "patient_account_number":
      if (!values.patient_account_number) return "Required";
      break;

    case "statement_date":
      if (!values.statement_date) return "Required";
      if (!isValidDate(values.statement_date)) return "Invalid date";
      break;

    case "patient_page_from":
    case "patient_page_to":
      if (totalPages > 0) {
        if (
          values?.patient_page_from <= 0 ||
          values?.patient_page_from === "" ||
          values?.patient_page_from > totalPages ||
          values?.patient_page_from > values?.patient_page_to
        ) {
          return "Invalid Page Number";
        }
        if (
          values?.patient_page_to <= 0 ||
          values?.patient_page_to === "" ||
          values?.patient_page_to > totalPages ||
          values?.patient_page_from > values?.patient_page_to
        ) {
          return "Invalid Page Number";
        }
      }
      break;

    case "qdx_status":
      if (isAdditional && isAdditionalInfoOptions?.status && values?.qdx_status === "") {
        return "Required";
      }
      break;

    case "qdx_reason":
      if (
        isAdditional &&
        isAdditionalInfoOptions?.status &&
        isAdditionalInfoOptions?.reason &&
        values?.qdx_status === "INCOMPLETE" &&
        values?.qdx_reason === ""
      ) {
        return "Required";
      }
      break;
    case "overall_page_from":
        const result = validateOverallPageFrom(values.overall_page_from, values, context);
            if (result) {
                return result
            };
        break;
    case "overall_page_to":
        const result1 = validateOverallPageTo(values.overall_page_to, values, context);
            if (result1) {
                return  result1
            };
        break;
    default:
      return undefined;
  }
}

export const  validatePPFull = (values ,context) => {
  let errors = {};

  if (values?.qdx_status !== "INCOMPLETE") {
    ["overall_page_from","overall_page_to","payer_account_number","check_number", "check_date", "check_amount", "patient_account_number", "statement_date", "patient_page_from", "patient_page_to", "qdx_status", "qdx_reason"]
      .forEach((field) => {
        const error = validateField(field, values ,context);
        if (error) errors[field] = error;
      });
  } else {
    // when status is INCOMPLETE -> only validate dates
    ["check_date", "statement_date"].forEach((field) => {
      const error = validateField(field, values ,context);
      if (error) errors[field] = error;
    });
  }

  return errors;
};


export const validateFieldPatientPay = (
  fieldNames,
  values,
  setError,
  clearErrors,
  context
) => {
  // run your custom validation
  fieldNames.forEach((fieldName) => {
    const errorMessage = validateField(fieldName, values, context);

    if (errorMessage) {
      setError(fieldName, { type: "custom", message: errorMessage });
    } else {
      clearErrors(fieldName);
    }
  });
}